'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var singleStrategy = function singleStrategy(modifier) {
  var items = modifier.items;

  return {
    isCompleted: false,
    minSelection: 1,
    maxSelection: 1,
    isValid: _lodash2.default.some(items, ['selected', true]),

    update: function update(tappedItem) {
      return items.map(function (i) {
        if (i.id === tappedItem.id) {
          return _extends({}, tappedItem, {
            selected: true
          });
        }

        return _extends({}, i, {
          selected: false
        });
      });
    }
  };
};

var multiRangeStrategy = function multiRangeStrategy(modifier) {
  var items = modifier.items;
  var selected = items.filter(function (i) {
    return i.selected;
  }).length;
  var maxSelection = modifier.max_selection_points || 1;
  var minSelection = modifier.min_selection_points || 0;
  var remaining = maxSelection - selected;

  return {
    selected: selected,
    remaining: remaining,
    minSelection: minSelection,
    maxSelection: maxSelection,
    isCompleted: remaining === 0,
    isValid: selected >= minSelection && selected <= maxSelection,

    update: function update(tappedItem) {
      return items.map(function (i) {
        if (i.id === tappedItem.id) {
          return _extends({}, tappedItem, {
            selected: !tappedItem.selected
          });
        }

        return i;
      });
    }
  };
};

exports.default = {
  SINGLE: singleStrategy,
  MULTI_RANGE: multiRangeStrategy
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/helpers/price-strategy.js
// module id = 193
// module chunks = 0